import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useAnvilProps } from "frontend/hooks";
import { RichText } from "frontend/wagtail/components/RichText";
import { Button, Heading, Stack } from "@chakra-ui/react";
import {analytics, anvilAnalyticsConfig} from "../../../analytics/static_src/anvil-analytics/analytics";


export default function ThanksScreen() {
    const {
        messages,
        cookies
    } = useAnvilProps();

    const [redirectUrl, setRedirectUrl] = useState('/');

    useEffect(() => {
        analytics.page(anvilAnalyticsConfig.page_payload);
    }, [])

    useEffect(() => {
        // Grab the saved redirect url from the cookies before deleting them
        if (cookies && cookies.order_tunnel_finished_redirect_url) {
            const cookieRedirectUrl = Cookies.get(cookies.order_tunnel_finished_redirect_url);
            if (cookieRedirectUrl) {
                setRedirectUrl(cookieRedirectUrl);
            }
        }

        // Delete the cookies that get set to handle social logins
        Object.entries(cookies).forEach(([, cookie_key]) => Cookies.remove(cookie_key));
        }, [cookies]);

    return (
        <Stack spacing={4}>
            <Heading size={"lg"}>{messages.thanks_header}</Heading>
            <RichText data={messages.thanks_body}/>
            <Heading size={"md"}>{messages.thanks_page_return_header}</Heading>
            <Button
                as={"a"}
                colorScheme={"blue"}
                width={'max-content'}
                href={redirectUrl}
                sx={{"&:hover,&:focus": {color: "white"}}}
            >
                {messages.thanks_page_return_button_text}
            </Button>
        </Stack>
    );
}
